import { Data, NeoModel } from '@singularsystems/neo-core';
import { PartialPlainObject } from '@singularsystems/neo-core/dist/Model';
import { Views } from '@singularsystems/neo-react';
import { AppService, Types } from '../../../App/Services/AppService';
import StaticEventLookup from '../Models/StaticEventSearchModal/StaticEventLookup';
import EventMappingSearchCriteria from '../Models/EventSearchCriteria';
import ManageStaticEventComponentVM from '../../../Maintenance/StaticEvents/Components/ManageStaticEventComponentVM';
import EventMappingLookup from '../Models/EventMappingLookup';

@NeoModel
export default class MapEventComponentVM extends Views.ViewModelBase {

    constructor(
        public eventApiClient = AppService.get(Types.ApiClients.EventMappingApiClient),
        taskRunner = AppService.get(Types.Neo.TaskRunner)) {
        super(taskRunner);
    }

    public eventMappingSearchCriteria = new EventMappingSearchCriteria();
    public selectedEventMapping = new StaticEventLookup();
    public manageStaticEventComponentVM = new ManageStaticEventComponentVM();
    public eventMappingUpdateList: EventMappingLookup[] = [];
  public showAddNewEventModalInd: boolean = false;
  public eventName: string = "";

    public pageManager = new Data.PageManager(this.eventMappingSearchCriteria, StaticEventLookup, this.eventApiClient.getStaticEvents, {
        pageSize: 10,
        sortAscending: false,
        fetchInitial: true,
        initialTaskRunner: this.taskRunner
    });

    public async initialise() {
    }

    public closeAddEventModal() {
        this.showAddNewEventModalInd = false;
        this.manageStaticEventComponentVM.managedStaticEvent = new StaticEventLookup();
    }

    public async clearSearch() {
        this.eventMappingSearchCriteria.meta.searchCriteria.value = "";
        await this.pageManager.refreshData();
    }

    public showAddEventModal(eventName: string) {
        this.manageStaticEventComponentVM = new ManageStaticEventComponentVM();
        this.manageStaticEventComponentVM.managedStaticEvent.staticEventName = eventName;
        this.showAddNewEventModalInd = true;
    }

    public SelectGenericEvent(selectedStaticEvent: StaticEventLookup) {
        var staticEvents = this.pageManager.data.filter(c => c.selected === true);
        for(var i = 0; i < staticEvents.length; i++){
            if(staticEvents[i].staticEventID !== selectedStaticEvent.staticEventID){
                staticEvents[i].selected = false;
            }
        }
        this.pageManager.data.update(staticEvents as unknown as PartialPlainObject<StaticEventLookup>[]);
        this.selectedEventMapping = selectedStaticEvent.selected === true ? selectedStaticEvent : new StaticEventLookup();
    }

}